/**
 * deditUser module
 * Checks for the user credentials which may have expired or not exist
 * then deletes or edits a user
 */

import appConstants from '../constants/appConstants';
import checkCredentials from '../authentication/checkCredentials';
import getUserAttributes from '../authentication/getUserAttributes';
import store from '../reducers/store';
import deleteTargetUserProfile from './deleteTargetUserProfile';

function editUser(key, action, newValues) {
  return new Promise((resolve, reject) => {
    checkCredentials().then(() => {
      const userList = store.getState().lists.schoolUsersList;

      if (key.length > 0) {
        var targetUser = userList.find((user) => {
          const attributesObj = user.Attributes;
          const objKeys = Object.keys(attributesObj);

          let correctUser = false;

          objKeys.forEach((objKey) => {
            const targetAtt = attributesObj[objKey];

            if (targetAtt.Name === 'sub' && targetAtt.Value === key) {
              correctUser = true;
            }
          });

          return correctUser;
        });
      }

      const cognitoISP = new AWS.CognitoIdentityServiceProvider();
      const params = {
        UserPoolId: localStorage.zcruitUserPoolId,
      };

      if (action !== 'create') {
        params.Username = targetUser.Username;
      }

      if (action === 'update') {
        const targetEmail = targetUser.Attributes.find((att) => att.Name === 'email');

        if (targetUser && newValues.name !== targetUser.Username) {
          // username can't be changed in cognito
          console.log('userName can not be changed');
        }

        if (targetEmail === null || newValues.email != targetEmail.Value) {
          if (newValues.email.length > 2) {
            var attribute = {
              Name: 'email',
              Value: newValues.email,
            };
          }

          const attributeList = [];

          attributeList.push(attribute);

          params.UserAttributes = attributeList;

          cognitoISP.adminUpdateUserAttributes(params, (err, data) => {
            if (err) {
              console.log(err);
            } else {
              const newUsersList = userList.filter((user) => user.Username != targetUser.Username);

              store.dispatch({ type: 'UPDATE_SCHOOL_USERS_LIST', schoolUsersList: newUsersList });
            }
          });
        }
        if (newValues.role === 'Administrator' && !targetUser.SuperUser) {
          params.GroupName = 'SuperUser';
          delete params.UserAttributes;
          cognitoISP.adminAddUserToGroup(params, (err, data) => {
            if (err) {
              console.log(err);
            }
          });
        } else if (newValues.role !== 'Administrator' && targetUser.SuperUser) {
          params.GroupName = 'SuperUser';
          delete params.UserAttributes;
          cognitoISP.adminRemoveUserFromGroup(params, (err, data) => {
            if (err) {
              console.log(err);
            }

            return;
          });
        }
      }

      if (action === 'delete') {
        cognitoISP.adminDisableUser(params, (err, data) => {
          if (err) {
            console.log(err);
          } else {
            var newUsersList = userList.filter((user) => user.Username != targetUser.Username);

            store.dispatch({ type: 'UPDATE_SCHOOL_USERS_LIST', schoolUsersList: newUsersList });
          }
        });
      } else if (action === 'create') {
        params.Username = newValues.name;

        attribute = {
          Name: 'email',
          Value: newValues.email,
        };

        const groupParams = {};

        let superUser = false;

        if (newValues.role === 'Administrator') {
          groupParams.GroupName = 'SuperUser';
          groupParams.Username = newValues.name;
          groupParams.UserPoolId = localStorage.zcruitUserPoolId;

          superUser = true;
        }

        const attributeList = [];

        attributeList.push(attribute);

        params.UserAttributes = attributeList;

        cognitoISP.adminCreateUser(params, (err, data) => {
          if (!err) {
            if (superUser) {
              data.User.SuperUser = true;
              cognitoISP.adminAddUserToGroup(groupParams, (err, groupData) => {
                if (err) {
                  reject(err);
                } else {
                  const newUsersList = userList.slice();

                  newUsersList.push(data.User);

                  store.dispatch({
                    type: 'UPDATE_SCHOOL_USERS_LIST',
                    schoolUsersList: newUsersList,
                  });
                }

                resolve(data);
              });
            } else {
              data.User.SuperUser = false;

              const newUsersList = userList.slice();

              newUsersList.push(data.User);

              store.dispatch({ type: 'UPDATE_SCHOOL_USERS_LIST', schoolUsersList: newUsersList });

              resolve(data);
            }
          }
        });
      } else {
        return 'invalid action ' + action;
      }
    });
  });
}

export default editUser;



// WEBPACK FOOTER //
// ./src/userFunctions/editUser.js